import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, User } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';
import { LanguageSwitcher } from '../UI/LanguageSwitcher';
// import { OnboardingReplayButton } from '../Onboarding/OnboardingReplayButton'; // DISABLED
import toast from 'react-hot-toast';

export const Header: React.FC = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      toast.success(t('auth.logoutSuccess'));
      navigate('/login');
    } catch {
      toast.error(t('auth.logoutFailed'));
    }
  };

  // Get role label from translations
  const getRoleLabel = (role: string) => {
    return t(`roles.${role}`, { defaultValue: role });
  };

  return (
    <header className="bg-white shadow-sm px-6 py-4">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            {t('auth.loginTitle')}
          </h2>
        </div>

        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2 text-gray-600">
            <User className="w-5 h-5" />
            <span className="font-medium">{user?.username}</span>
            <span className="text-sm text-gray-400">
              ({user ? getRoleLabel(user.role) : ''})
            </span>
          </div>

          <LanguageSwitcher />

          {/* <OnboardingReplayButton /> - DISABLED */}

          <button
            onClick={handleLogout}
            className="flex items-center px-3 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
          >
            <LogOut className="w-5 h-5 mr-2" />
            <span>{t('auth.logout')}</span>
          </button>
        </div>
      </div>
    </header>
  );
};
